import FacebookIcon from "@page-js/Components/Social/FacebookIcon.vue";
import InstagramIcon from "@page-js/Components/Social/InstagramIcon.vue";
import KakaotalkIcon from "@page-js/Components/Social/KakaotalkIcon.vue";
import LinkedinIcon from "@page-js/Components/Social/LinkedinIcon.vue";
import LinkIcon from "@page-js/Components/Social/LinkIcon.vue";
import NaverBandIcon from "@page-js/Components/Social/NaverBandIcon.vue";
import NaverBlogIcon from "@page-js/Components/Social/NaverBlogIcon.vue";
import NaverSmartstoreIcon from "@page-js/Components/Social/NaverSmartstoreIcon.vue";
import NaverIcon from "@page-js/Components/Social/NaverIcon.vue";
import PinterestIcon from "@page-js/Components/Social/PinterestIcon.vue";
import TiktokIcon from "@page-js/Components/Social/TiktokIcon.vue";
import TwitterXIcon from "@page-js/Components/Social/TwitterXIcon.vue";
import HomepageIcon from "@page-js/Components/Social/HomepageIcon.vue";
import YoutubeIcon from "@page-js/Components/Social/YoutubeIcon.vue";

export const platforms = [
  { title: "페이스북", name: "facebook", component: FacebookIcon },
  { title: "인스타그램", name: "instagram", component: InstagramIcon },
  { title: "유튜브", name: "youtube", component: YoutubeIcon },
  { title: "네이버", name: "naver", component: NaverIcon },
  { title: "네이버 밴드", name: "naverband", component: NaverBandIcon },
  { title: "네이버 블로그", name: "naverblog", component: NaverBlogIcon },
  { title: "네이버 스마트스토어", name: "naversmartstore", component: NaverSmartstoreIcon }, //
  { title: "카카오", name: "kakaotalk", component: KakaotalkIcon },
  { title: "틱톡", name: "tiktok", component: TiktokIcon },
  { title: "핀터레스트", name: "pinterest", component: PinterestIcon },
  { title: "링크드인", name: "linkedin", component: LinkedinIcon },
  { title: "X", name: "x", component: TwitterXIcon },
  { title: "홈페이지", name: "homepage", component: HomepageIcon }, //
  { title: "기타", name: "link", component: LinkIcon },
];

export const getPlatformIcon = (name) => {
  const platform = platforms.find((platform) => platform.name === name);

  return platform ? platform.component : LinkIcon;
};

export const getPlatformTitle = (name) => {
  const platform = platforms.find((platform) => platform.name === name);

  return platform ? platform.title : "기타";
};
